import { render } from "./notFoundView.vue?vue&type=template&id=64b70bfa"
import script from "./notFoundView.vue?vue&type=script&lang=js"
export * from "./notFoundView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__